import type { FormStructure, FormStateObject } from './Form.types';
import type { ValidationFieldError } from '../validation/Validation.types';

const setFormAsTouched = (form: FormStructure, errors: ValidationFieldError): FormStateObject => {
  const isTouched = {};
  const fields = Object.keys(form.isTouched);
  fields.forEach((field) => {
    isTouched[field] = true;
  });
  return {
    form: { ...form, errors: { ...errors }, isTouched },
  };
};

export default setFormAsTouched;
